import React, { useRef, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import parse from 'html-react-parser';
import cards from './cards.json';
import classic from './assets/cards/classic.svg';
import silver from './assets/cards/silver.svg';
import gold from './assets/cards/gold.svg';
import platinum from './assets/cards/platinum.svg';
import diamond from './assets/cards/diamond.svg';
import 'swiper/swiper.scss';
import './cards.scss';

const cardImages = { classic, silver, gold, platinum, diamond };

export default function MembershipCards() {
  const swiperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const syncActiveSlide = (swiper) => {
    setCurrentIndex(swiper.realIndex);
    // Loop copies also report isActive; expose only Swiper's physical active slide.
    swiper.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', String(index !== swiper.activeIndex));
    });
  };

  return (
    <section className="accor-tiers" aria-labelledby="accor-tiers-title">
      <h2 className="accor-tiers__title" id="accor-tiers-title">{cards.title}</h2>
      <p className="accor-tiers__intro">{cards.intro}</p>
      <div className="accor-tiers__cards">
        <Swiper
          className="accor-tiers__swiper"
          slidesPerView={1}
          spaceBetween={0}
          loop
          speed={300}
          autoplay={false}
          onSwiper={(swiper) => { swiperRef.current = swiper; syncActiveSlide(swiper); }}
          onSlideChange={syncActiveSlide}
          onLoopFix={syncActiveSlide}
        >
          {cards.cards.map((card) => (
            <SwiperSlide key={card.id} role="group" aria-label={card.imageAlt}>
              <div className="accor-tier-card">
                <div className="accor-tier-card__content">
                  <div className="accor-tier-card__wrapper">
                    <img className="accor-tier-card__image" src={cardImages[card.id]} alt={card.imageAlt} width="736" height="490" />
                    <span className="accor-tier-card__label">{card.label}</span>
                    <hr className="accor-tier-card__separator" />
                    <p className="accor-tier-card__description">{card.description}</p>
                    <ul className="accor-tier-card__advantages">
                      {card.advantages.map((advantage) => (
                        <li key={advantage}>
                          <span className="accor-tier-card__check" aria-hidden="true" />
                          <span>{advantage}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {card.bonus && (
                    <div className="accor-tier-card__bonus">
                      <hr className="accor-tier-card__separator" />
                      <p>{parse(card.bonus)}</p>
                    </div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="accor-tiers__controls">
          <button type="button" aria-label="上一个会员等级" title="上一个会员等级" onClick={() => swiperRef.current?.slidePrev()}>
            <LeftOutlined aria-hidden="true" />
          </button>
          <div className="accor-tiers__pagination" role="status" aria-live="polite" aria-atomic="true">
            <span>{currentIndex + 1} / {cards.cards.length}</span>
          </div>
          <button type="button" aria-label="下一个会员等级" title="下一个会员等级" onClick={() => swiperRef.current?.slideNext()}>
            <RightOutlined aria-hidden="true" />
          </button>
        </div>
      </div>
      
    </section>
  );
}
